Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  CommitmentState: true,
  StepState: true,
  ApplicationRecord: true,
  Announcement: true,
  User: true,
  Notification: true,
  Country: true,
  Region: true,
  PeopleWhatNext: true,
  AviationEstimate: true,
  PeopleAviationFootprint: true,
  PeopleAviationFootprintEstimate: true,
  CarEstimate: true,
  CarModel: true,
  PeopleCarFootprint: true,
  DietEstimate: true,
  PeopleDietFootprint: true,
  HouseType: true,
  HouseholdsElectricityFootprint: true,
  HouseholdsGasFootprint: true,
  ElectricityEstimate: true,
  GasEstimate: true,
  Person: true,
  Goal: true,
  PeopleGoal: true,
  Footprint: true,
  Action: true,
  Commitment: true,
  Impact: true,
  Theme: true,
  PeopleActionsSuppression: true,
  Campaign: true,
  CampaignTargetModel: true,
  CampaignAction: true,
  Team: true,
  GroupMembershipOrganization: true,
  GroupMembershipRequest: true,
  GroupMembershipTeam: true,
  GroupMembership: true,
  Organization: true,
  OrganizationInvitationBatch: true,
  PersonalChecklistItem: true,
  PeopleAnnouncement: true,
  PeopleClickAnalytic: true,
  PeopleFootprintCard: true,
  PeopleFootprint: true,
  TopAction: true
};
Object.defineProperty(exports, "Action", {
  enumerable: true,
  get: function get() {
    return _Action.Action;
  }
});
Object.defineProperty(exports, "Announcement", {
  enumerable: true,
  get: function get() {
    return _Announcement.Announcement;
  }
});
Object.defineProperty(exports, "ApplicationRecord", {
  enumerable: true,
  get: function get() {
    return _ApplicationRecord.ApplicationRecord;
  }
});
Object.defineProperty(exports, "AviationEstimate", {
  enumerable: true,
  get: function get() {
    return _AviationEstimate.AviationEstimate;
  }
});
Object.defineProperty(exports, "Campaign", {
  enumerable: true,
  get: function get() {
    return _Campaign.Campaign;
  }
});
Object.defineProperty(exports, "CampaignAction", {
  enumerable: true,
  get: function get() {
    return _CampaignAction.CampaignAction;
  }
});
Object.defineProperty(exports, "CampaignTargetModel", {
  enumerable: true,
  get: function get() {
    return _CampaignTargetModel.CampaignTargetModel;
  }
});
Object.defineProperty(exports, "CarEstimate", {
  enumerable: true,
  get: function get() {
    return _CarEstimate.CarEstimate;
  }
});
Object.defineProperty(exports, "CarModel", {
  enumerable: true,
  get: function get() {
    return _CarModel.CarModel;
  }
});
Object.defineProperty(exports, "Commitment", {
  enumerable: true,
  get: function get() {
    return _Commitment.Commitment;
  }
});
exports.CommitmentState = void 0;
Object.defineProperty(exports, "Country", {
  enumerable: true,
  get: function get() {
    return _Country.Country;
  }
});
Object.defineProperty(exports, "DietEstimate", {
  enumerable: true,
  get: function get() {
    return _DietEstimate.DietEstimate;
  }
});
Object.defineProperty(exports, "ElectricityEstimate", {
  enumerable: true,
  get: function get() {
    return _ElectricityEstimate.ElectricityEstimate;
  }
});
Object.defineProperty(exports, "Footprint", {
  enumerable: true,
  get: function get() {
    return _Footprint.Footprint;
  }
});
Object.defineProperty(exports, "GasEstimate", {
  enumerable: true,
  get: function get() {
    return _GasEstimate.GasEstimate;
  }
});
Object.defineProperty(exports, "Goal", {
  enumerable: true,
  get: function get() {
    return _Goal.Goal;
  }
});
Object.defineProperty(exports, "GroupMembership", {
  enumerable: true,
  get: function get() {
    return _GroupMembership.GroupMembership;
  }
});
Object.defineProperty(exports, "GroupMembershipOrganization", {
  enumerable: true,
  get: function get() {
    return _GroupMembershipOrganization.GroupMembershipOrganization;
  }
});
Object.defineProperty(exports, "GroupMembershipRequest", {
  enumerable: true,
  get: function get() {
    return _GroupMembershipRequest.GroupMembershipRequest;
  }
});
Object.defineProperty(exports, "GroupMembershipTeam", {
  enumerable: true,
  get: function get() {
    return _GroupMembershipTeam.GroupMembershipTeam;
  }
});
Object.defineProperty(exports, "HouseType", {
  enumerable: true,
  get: function get() {
    return _HouseType.HouseType;
  }
});
Object.defineProperty(exports, "HouseholdsElectricityFootprint", {
  enumerable: true,
  get: function get() {
    return _HouseholdsElectricityFootprint.HouseholdsElectricityFootprint;
  }
});
Object.defineProperty(exports, "HouseholdsGasFootprint", {
  enumerable: true,
  get: function get() {
    return _HouseholdsGasFootprint.HouseholdsGasFootprint;
  }
});
Object.defineProperty(exports, "Impact", {
  enumerable: true,
  get: function get() {
    return _Impact.Impact;
  }
});
Object.defineProperty(exports, "Notification", {
  enumerable: true,
  get: function get() {
    return _Notification.Notification;
  }
});
Object.defineProperty(exports, "Organization", {
  enumerable: true,
  get: function get() {
    return _Organization.Organization;
  }
});
Object.defineProperty(exports, "OrganizationInvitationBatch", {
  enumerable: true,
  get: function get() {
    return _OrganizationInvitationBatch.OrganizationInvitationBatch;
  }
});
Object.defineProperty(exports, "PeopleActionsSuppression", {
  enumerable: true,
  get: function get() {
    return _PeopleActionsSuppression.PeopleActionsSuppression;
  }
});
Object.defineProperty(exports, "PeopleAnnouncement", {
  enumerable: true,
  get: function get() {
    return _PeopleAnnouncement.PeopleAnnouncement;
  }
});
Object.defineProperty(exports, "PeopleAviationFootprint", {
  enumerable: true,
  get: function get() {
    return _PeopleAviationFootprint.PeopleAviationFootprint;
  }
});
Object.defineProperty(exports, "PeopleAviationFootprintEstimate", {
  enumerable: true,
  get: function get() {
    return _PeopleAviationFootprintEstimate.PeopleAviationFootprintEstimate;
  }
});
Object.defineProperty(exports, "PeopleCarFootprint", {
  enumerable: true,
  get: function get() {
    return _PeopleCarFootprint.PeopleCarFootprint;
  }
});
Object.defineProperty(exports, "PeopleClickAnalytic", {
  enumerable: true,
  get: function get() {
    return _PeopleClickAnalytic.PeopleClickAnalytic;
  }
});
Object.defineProperty(exports, "PeopleDietFootprint", {
  enumerable: true,
  get: function get() {
    return _PeopleDietFootprint.PeopleDietFootprint;
  }
});
Object.defineProperty(exports, "PeopleFootprint", {
  enumerable: true,
  get: function get() {
    return _PeopleFootprint.PeopleFootprint;
  }
});
Object.defineProperty(exports, "PeopleFootprintCard", {
  enumerable: true,
  get: function get() {
    return _PeopleFootprintCard.PeopleFootprintCard;
  }
});
Object.defineProperty(exports, "PeopleGoal", {
  enumerable: true,
  get: function get() {
    return _PeopleGoal.PeopleGoal;
  }
});
Object.defineProperty(exports, "PeopleWhatNext", {
  enumerable: true,
  get: function get() {
    return _PeopleWhatNext.PeopleWhatNext;
  }
});
Object.defineProperty(exports, "Person", {
  enumerable: true,
  get: function get() {
    return _Person.Person;
  }
});
Object.defineProperty(exports, "PersonalChecklistItem", {
  enumerable: true,
  get: function get() {
    return _PersonalChecklistItem.PersonalChecklistItem;
  }
});
Object.defineProperty(exports, "Region", {
  enumerable: true,
  get: function get() {
    return _Region.Region;
  }
});
exports.StepState = void 0;
Object.defineProperty(exports, "Team", {
  enumerable: true,
  get: function get() {
    return _Team.Team;
  }
});
Object.defineProperty(exports, "Theme", {
  enumerable: true,
  get: function get() {
    return _Theme.Theme;
  }
});
Object.defineProperty(exports, "TopAction", {
  enumerable: true,
  get: function get() {
    return _TopAction.TopAction;
  }
});
Object.defineProperty(exports, "User", {
  enumerable: true,
  get: function get() {
    return _User.User;
  }
});
var _ApplicationRecord = require("./ApplicationRecord");
var _Announcement = require("./Announcement");
var _User = require("./User");
var _Notification = require("./Notification");
var _Country = require("./Country");
var _Region = require("./Region");
var _PeopleWhatNext = require("./PeopleWhatNext");
var _AviationEstimate = require("./AviationEstimate");
var _PeopleAviationFootprint = require("./PeopleAviationFootprint");
var _PeopleAviationFootprintEstimate = require("./PeopleAviationFootprintEstimate");
var _CarEstimate = require("./CarEstimate");
var _CarModel = require("./CarModel");
var _PeopleCarFootprint = require("./PeopleCarFootprint");
var _DietEstimate = require("./DietEstimate");
var _PeopleDietFootprint = require("./PeopleDietFootprint");
var _HouseType = require("./HouseType");
var _HouseholdsElectricityFootprint = require("./HouseholdsElectricityFootprint");
var _HouseholdsGasFootprint = require("./HouseholdsGasFootprint");
var _ElectricityEstimate = require("./ElectricityEstimate");
var _GasEstimate = require("./GasEstimate");
var _Person = require("./Person");
var _Goal = require("./Goal");
var _PeopleGoal = require("./PeopleGoal");
var _Footprint = require("./Footprint");
var _Action = require("./Action");
var _Commitment = require("./Commitment");
var _Impact = require("./Impact");
var _Theme = require("./Theme");
var _PeopleActionsSuppression = require("./PeopleActionsSuppression");
var _Campaign = require("./Campaign");
var _CampaignTargetModel = require("./CampaignTargetModel");
var _CampaignAction = require("./CampaignAction");
var _Team = require("./Team");
var _GroupMembershipOrganization = require("./GroupMembershipOrganization");
var _GroupMembershipRequest = require("./GroupMembershipRequest");
var _GroupMembershipTeam = require("./GroupMembershipTeam");
var _GroupMembership = require("./GroupMembership");
var _Organization = require("./Organization");
var _OrganizationInvitationBatch = require("./OrganizationInvitationBatch");
var _PersonalChecklistItem = require("./PersonalChecklistItem");
var _PeopleAnnouncement = require("./PeopleAnnouncement");
var _Leaderboards = require("./Leaderboards");
Object.keys(_Leaderboards).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Leaderboards[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Leaderboards[key];
    }
  });
});
var _PeopleClickAnalytic = require("./PeopleClickAnalytic");
var _PeopleFootprintCard = require("./PeopleFootprintCard");
var _PeopleFootprint = require("./PeopleFootprint");
var _TopAction = require("./TopAction");
var CommitmentState = exports.CommitmentState = function (CommitmentState) {
  CommitmentState["successful"] = "successful";
  CommitmentState["existing"] = "existing";
  CommitmentState["complete"] = "complete";
  CommitmentState["abandoned"] = "abandoned";
  CommitmentState["pending"] = "pending";
  return CommitmentState;
}({});
var StepState = exports.StepState = function (StepState) {
  StepState["applicable"] = "applicable";
  StepState["complete"] = "complete";
  StepState["existing"] = "existing";
  return StepState;
}({});